// extracted by mini-css-extract-plugin
export default {"slide_partenaires":"SlidesPartenaires_slide_partenaires__aGJj5"};